import { motion } from "framer-motion";
import { Shield, Clock, MapPin, Headphones, CreditCard, Star } from "lucide-react";

const features = [
  { icon: Shield, title: "Licensed & Insured", desc: "Fully licensed fleet with comprehensive insurance for your peace of mind" },
  { icon: Clock, title: "On-Time Guarantee", desc: "We track your flight and adjust pickup times — never wait, never rush" },
  { icon: MapPin, title: "Door-to-Door Service", desc: "From airport to hotel or any destination across the Dominican Republic" },
  { icon: Headphones, title: "24/7 Support", desc: "Our team is available around the clock for any questions or changes" },
  { icon: CreditCard, title: "Transparent Pricing", desc: "No hidden fees. The price you see is the price you pay, always" },
  { icon: Star, title: "5-Star Experience", desc: "Thousands of happy travelers rate us as the top transfer service in DR" },
];

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <span className="text-secondary font-semibold text-sm uppercase tracking-widest">Why Choose Us</span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mt-2">
            What Sets Us Apart
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="bg-white border border-border/50 rounded-none p-6 hover:border-secondary/30 hover:shadow-md transition-all"
            >
              <div className="w-12 h-12 bg-secondary/10 rounded-none flex items-center justify-center mb-4">
                <f.icon className="w-6 h-6 text-secondary" />
              </div>
              <h3 className="font-display font-bold text-foreground text-lg mb-2">{f.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
